;(function($) {
    'use strict';

    var PasswordChecker = function ($object, options) {
        var defaults = {
            shortPass: ACC.passwordChecker.shortPass,
            weakPass: ACC.passwordChecker.weakPass,
            mediumPass: ACC.passwordChecker.mediumPass,
            strongPass: ACC.passwordChecker.strongPass,
            containsUsername: ACC.passwordChecker.containsUsername,
            username: false,
            messageBox: ''
        };

        options = $.extend({}, defaults, options);

        function init() {
            var shown = false;
            var $insert = $('<div>');

            if(!options.messageBox){
                $object.after($insert)
            }else{
                $insert = $(options.messageBox);
            }

            $object.on('keyup', function() {

                var password = $(this).val() ||'';
                var username = options.username || '';
                if (username && $(username).length && $(username).val()) {
                    username = $(username).val();
                    if (password.toLowerCase() === username.toLowerCase()
                        || password.toLowerCase().match(new RegExp(username.toLowerCase()))) {
                        $insert.removeClass().addClass('pass-wrapper alert alert-error').html(options.containsUsername);
                        return;
                    }
                }

                var strongRegex = new RegExp("^(?=.{8,})(?=.*[!,@,#,$,%,^,&,*,?,_,~])(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).*$", "g");
                var mediumRegex = new RegExp("^(?=.{6,})(((?=.*[!,@,#,$,%,^,&,*,?,_,~])(?=.*[a-zA-Z]))|((?=.*[a-zA-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[A-Z]))|((?=.*[!,@,#,$,%,^,&,*,?,_,~])(?=.*[0-9]))).*$", "g");
                var okRegex = new RegExp("(?=.{6,}).*", "g");

                if (okRegex.test($(this).val()) === false) {
                    $insert.removeClass().addClass('pass-wrapper alert alert-error').html(options.shortPass);
                } else if (strongRegex.test($(this).val())) {
                    $insert.removeClass().addClass('pass-wrapper alert alert-success').html(options.strongPass);
                } else if (mediumRegex.test($(this).val())) {
                    $insert.removeClass().addClass('pass-wrapper alert alert-info').html(options.mediumPass);
                } else {
                    $insert.removeClass().addClass('pass-wrapper alert alert-error').html(options.weakPass);
                }
            });

            return this;
        }

        return init.call(this);
    };

    // Bind to jquery
    $.fn.passwordChecker = function(options) {
        return this.each(function() {
            new PasswordChecker($(this), options);
        });
    };
})(jQuery);

$(document).ready(function () {
    if($("#pwd").length){
        $("#pwd").passwordChecker({
            username: '#uid',
            messageBox: '.pass-wrapper'
        });
    }

    if($("#password").length){
        $("#password").passwordChecker({
            username: '#email',
            messageBox: '.pass-wrapper'
        });
    }

    if($("#update-pwd").length){
        $("#update-pwd").passwordChecker({
            messageBox: '.pass-wrapper'
        });
    }
});